















































import Vue, { PropType } from 'vue';
import { SchoolEvent } from '../../services/SchoolEventService';

export default Vue.extend({
    name: 'SchoolEventCard',
    props: {
        event: {
            type: Object as PropType<SchoolEvent>,
            required: true,
        },
        isRegistered: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        isNow(): boolean {
            const now = new Date();
            return this.event.startTime <= now && this.event.endTime >= now;
        },
        startTime(): string {
            return this.event.startTime.toLocaleString('en-GB', {
                hour: 'numeric',
                minute: 'numeric',
                timeZoneName: 'short',
            });
        },
        eventDates(): string {
            const startDate = this.event.startTime;
            const endDate = this.event.endTime;
            const startYearFormat =
                startDate.getFullYear() !== endDate.getFullYear() ? 'numeric' : undefined;
            const startMonthFormat =
                startDate.getMonth() !== endDate.getMonth() ? 'long' : undefined;

            const start = startDate.toLocaleDateString('en-GB', {
                month: startMonthFormat,
                day: 'numeric',
                year: startYearFormat,
            });
            const end = endDate.toLocaleDateString('en-GB', {
                year: 'numeric',
                month: 'long',
                day: 'numeric',
            });
            return `${start} - ${end}`;
        },
        privacy(): { label: string; icon: string } {
            switch (this.event.privacy) {
                case 'private':
                    return {
                        label: this.$t('schoolevents.privacy.private').toString(),
                        icon: 'lock',
                    };
                case 'network':
                    return {
                        label: this.$t('schoolevents.privacy.network').toString(),
                        icon: 'lock',
                    };
                case 'invite':
                    return {
                        label: this.$t('schoolevents.privacy.invite').toString(),
                        icon: 'lock',
                    };
                default:
                    return {
                        label: this.$t('schoolevents.privacy.open').toString(),
                        icon: 'lock-open',
                    };
            }
        },
    },
});
